import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorStoreWarehouseView = () => {
  const { t } = useTranslation()

  const warehouseView = useCallback(
    (payload, callback, loading) => {
      ApiService.jsonRequest('/store-warehouse/view', payload, response => {
        if (response.status_code === 200) {
          callback(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 1500,
          })
        }
        loading(false)
      })
    },
    [t],
  )

  return { warehouseView }
}

export default InteractorStoreWarehouseView
